module.exports = __webpack_public_path__ + "media/tang_6.7bbe24ec.mp4";